const VIEWS={
  id(){
    const o=S.order;
    return `
    <div class="step-label">Étape 1 · Identification</div>
    <h2 class="q">Retrouvons ta commande</h2>
    <p class="sub">On récupère ta commande pour te faire gagner du temps : pas besoin de retaper les références.</p>
    <label class="f">Numéro de commande <span class="hint">(ex : #SIL-102345 — sur ton mail de confirmation)</span></label>
    <input type="text" id="ord" placeholder="#SIL-102345" value="${o?o.id:''}">
    <label class="f">Email de la commande</label>
    <input type="email" id="mail" placeholder="ton@email.fr" value="${o?o.email:(S.contact.email||'')}">
    <div class="err" id="e_id">Renseigne un email valide pour continuer.</div>
    <button class="btn ghost" id="lookup" style="margin-top:14px">Retrouver ma commande</button>
    ${o?`<div class="order"><b>Commande trouvée : ${o.id}</b> · ${o.date}<div class="hint">${o.products.length} article(s).</div></div>`:''}
    <div style="margin-top:16px"><button class="link" id="skip">Je n'ai pas mon numéro de commande</button></div>
    <div class="nav"><button class="btn ghost" id="back" style="visibility:hidden">← Retour</button>
      <button class="btn primary" id="next" ${(o||S.noOrder)?'':'disabled'}>Continuer →</button></div>`;
  },
  motif(){
    const cards=Object.entries(MOTIFS).map(([k,m])=>`<div class="opt ${S.motif===k?'sel':''}" data-k="${k}"><div><div class="t">${m.t}</div><div class="d">${m.d}</div></div></div>`).join('');
    return `<div class="step-label">Étape 2 · Motif</div><h2 class="q">Que se passe-t-il ?</h2><p class="sub">Choisis le motif le plus proche.</p><div class="grid">${cards}</div><div class="err" id="e_motif">Sélectionne un motif.</div>${navHTML()}`;
  },
  product(){
    if(S.noOrder||!S.order){
      return `<div class="step-label">Étape 3 · Produit concerné</div><h2 class="q">Quel produit est concerné ?</h2><p class="sub">Sans numéro de commande, indique le produit du mieux possible.</p><label class="f">Nom ou référence du produit <span class="req">*</span></label><input type="text" id="pfree" placeholder="ex : Ruban LED RGB 24V" value="${esc(S.answers.pfree||'')}"><div class="err" id="e_prod">Indique le produit concerné.</div>${navHTML()}`;
    }
    const list=S.order.products.map((p,i)=>`<div class="prod ${S.selProducts.includes(i)?'sel':''}" data-i="${i}"><div class="meta"><div class="n">${p.n}</div><div class="s">${p.s} · Qté ${p.q}</div></div><div class="chk">✓</div></div>`).join('');
    return `<div class="step-label">Étape 3 · Produit concerné</div><h2 class="q">Quel(s) article(s) de la commande ${S.order.id} ?</h2><p class="sub">Coche le ou les produits concernés.</p>${list}<div class="err" id="e_prod">Sélectionne au moins un produit.</div>${navHTML()}`;
  },
  famille(){
    if(S.famille===null) S.famille=detectFamille();
    const detected=S.famille?FAMILLES[S.famille].label:null;
    const cards=Object.entries(FAMILLES).map(([k,f])=>`<div class="opt ${S.famille===k?'sel':''}" data-f="${k}"><div><div class="t">${f.label}</div></div></div>`).join('');
    return `<div class="step-label">Étape 4 · Composant concerné</div>
      <h2 class="q">Sur quel élément porte le problème ?</h2>
      <p class="sub">On adapte les questions techniques au composant. Choisis le plus précis.</p>
      ${detected?`<div class="autodetect">Détecté d'après ta commande : <b>${detected}</b> — change si besoin.</div>`:''}
      <div class="grid">${cards}</div>
      <div class="err" id="e_fam">Sélectionne un composant.</div>${navHTML()}`;
  },
  diag(){
    const fam=FAMILLES[S.famille];
    if(!fam) return '<p>—</p>';
    let h=`<div class="step-label">Étape 5 · Diagnostic ciblé · ${fam.label}</div>
      <h2 class="q">Questions sur : ${fam.label}</h2>
      <p class="sub">On cible pour te répondre juste, sans allers-retours.</p>`;
    h+=field({id:'when',l:'Quand le problème est-il apparu ?',type:'select',opts:["Dès la mise sous tension / au déballage","Après quelques jours","Après quelques semaines","Après plusieurs mois"],req:true});
    fam.q.forEach(q=>h+=field(q));
    h+=field({id:'desc',l:'Précisions (facultatif)',type:'textarea',ph:'Tout détail utile...',req:false});
    h+=`<div class="tip"><b>Avant d'aller plus loin —</b> beaucoup de pannes se règlent en 2 min : vérifie l'alimentation (transfo/driver), coupe puis rétablis le courant 10 s, re-synchronise la télécommande (appui long ON).
      <div style="margin-top:8px"><button class="link" id="solved">C'est réglé, je ferme</button></div></div>`;
    h+=`<div class="err" id="e_q">Complète les champs obligatoires (marqués *).</div>`;
    h+=navHTML();
    return h;
  },
  q_casse(){
    return `<div class="step-label">Dommage transport</div><h2 class="q">Ton colis est arrivé abîmé</h2>
      ${field({id:'recdate',l:'Date de réception',type:'text',ph:'jj/mm/aaaa',req:true})}
      ${field({id:'pack',l:'Emballage extérieur visiblement endommagé ?',type:'select',opts:["Oui, carton écrasé / déchiré","Non, emballage intact mais produit cassé"],req:true})}
      ${field({id:'desc',l:'Décris la casse',type:'textarea',ph:'ex : la vitre du plafonnier est fêlée...',req:true})}
      <div class="tip"><b>Important —</b> photos du produit <u>et</u> de l'emballage (étiquette transporteur visible) à l'étape suivante.</div>
      <div class="err" id="e_q">Complète les champs obligatoires.</div>${navHTML()}`;
  },
  q_erreur(){
    return `<div class="step-label">Erreur de produit</div><h2 class="q">Tu as reçu le mauvais article</h2>
      ${field({id:'got',l:'Qu\'as-tu reçu à la place ?',type:'text',ph:'ex : un spot 5W au lieu du ruban',req:true})}
      ${field({id:'refgot',l:'Référence sur l\'étiquette du produit reçu',type:'text',ph:'ex : SP-5W-XX',req:false})}
      <div class="tip"><b>À noter —</b> une photo de l'étiquette du produit reçu accélère le traitement.</div>
      <div class="err" id="e_q">Indique le produit reçu.</div>${navHTML()}`;
  },
  q_manquant(){
    return `<div class="step-label">Pièce manquante</div><h2 class="q">Il manque quelque chose</h2>
      ${field({id:'desc',l:'Quelle pièce ou accessoire manque-t-il ?',type:'textarea',ph:'ex : le kit de fixation et la notice...',req:true})}
      ${field({id:'sealed',l:'Le colis était-il scellé à l\'extérieur ?',type:'select',opts:["Oui, colis scellé","Non, colis déjà ouvert / mal fermé"],req:false})}
      <div class="err" id="e_q">Décris la pièce manquante.</div>${navHTML()}`;
  },
  q_retract(){
    return `<div class="step-label">Rétractation</div><h2 class="q">Tu souhaites retourner ton produit</h2>
      ${field({id:'used',l:'Le produit est-il ouvert / installé ?',type:'select',opts:["Neuf, jamais ouvert","Ouvert mais non installé","Installé / testé"],req:true})}
      ${field({id:'desc',l:'Motif (facultatif)',type:'textarea',ph:'ex : la lumière est trop froide...',req:false})}
      <div class="tip"><b>Conditions —</b> rétractation sous 14 jours après réception, produit complet en état de revente. Frais de retour à ta charge sauf erreur de notre part.</div>
      <div class="err" id="e_q">Indique l'état du produit.</div>${navHTML()}`;
  },
  q_garantie(){
    return `<div class="step-label">Question / garantie</div><h2 class="q">Comment peut-on t'aider ?</h2>
      ${field({id:'desc',l:'Ta question',type:'textarea',ph:'ex : durée de garantie gamme pro ? / associer 2 télécommandes ?',req:true})}
      <div class="err" id="e_q">Écris ta question.</div>${navHTML()}`;
  },
  photo(){
    const req=(S.motif==='defaut'||S.motif==='casse'||S.motif==='erreur');
    return `<div class="step-label">Pièces jointes</div><h2 class="q">Ajoute une photo ou une vidéo ${req?'<span class="req">*</span>':''}</h2>
      <p class="sub">${req?"Obligatoire pour ce motif — c'est ce qui évite les allers-retours.":'Facultatif, mais ça aide.'}</p>
      <input type="file" id="fileinput" accept="image/*,video/*" multiple style="display:none">
      <div class="drop" id="drop">Glisse tes fichiers ici ou <u>clique pour parcourir</u><br><span class="hint">Photos ou vidéo — plusieurs fichiers possibles</span></div>
      <div class="thumbs" id="filelist"></div>
      <div class="err" id="e_photo">Ajoute au moins une photo pour ce motif.</div>${navHTML()}`;
  },
  solution(){
    const opts=[['remplacement','Remplacement à l\'identique'],['reparation','Réparation / dépannage'],['avoir','Un avoir'],['remboursement','Un remboursement'],['info','Juste une réponse / un conseil']]
      .map(([k,l])=>`<div class="opt ${S.solution===k?'sel':''}" data-sol="${k}"><div class="t">${l}</div></div>`).join('');
    return `<div class="step-label">Ta préférence</div><h2 class="q">Qu'attends-tu comme solution ?</h2><p class="sub">Ça nous oriente.</p><div class="grid">${opts}</div><div class="err" id="e_sol">Choisis une option.</div>${navHTML()}`;
  },
  contact(){
    return `<div class="step-label">Coordonnées</div><h2 class="q">Comment te recontacter ?</h2>
      <label class="f">Nom et prénom <span class="req">*</span></label><input type="text" id="nom" value="${esc(S.contact.nom||'')}" placeholder="Prénom Nom">
      <label class="f">Email <span class="req">*</span></label><input type="email" id="cmail" value="${esc(S.contact.email||(S.order?S.order.email:''))}" placeholder="ton@email.fr">
      <label class="f">Téléphone <span class="hint">(facultatif)</span></label><input type="tel" id="tel" value="${esc(S.contact.tel||'')}" placeholder="06 12 34 56 78">
      <div class="err" id="e_ct">Nom et email sont nécessaires.</div>${navHTML('Voir le message final')}`;
  },
  recap(){
    const paras=buildMessage().map(p=>`<p>${esc(p)}</p>`).join('');
    return `<div class="step-label">Étape finale · Vérification</div>
      <h2 class="q">Voici ta demande, rédigée pour le SAV</h2>
      <p class="sub">On a réuni toutes tes réponses en un message clair et complet. Vérifie, puis envoie.</p>
      <div class="msgbox" id="msgbox">${paras}</div>
      <button class="btn ghost" id="copy" style="margin-top:12px">Copier le message</button>
      <div class="nav"><button class="btn ghost" id="back">← Retour</button><button class="btn primary" id="send">Envoyer ma demande →</button></div>`;
  },
  done(){
    return `<div class="done"><div class="big">✓</div><h2 class="q">Demande envoyée&nbsp;!</h2>
      <p class="sub">Réf. suivi <b>SAV-2026-04821</b> — email de confirmation envoyé.</p>
      <p>Réponse sous <b>24&nbsp;h ouvrées</b>${S.motif==='casse'?' (litige transport : prioritaire)':''}.</p>
      <button class="btn ghost" id="restart" style="margin-top:14px">↻ Refaire une démo</button></div>`;
  }
};

/* ---------- construction du message (paragraphes) ---------- */
function prodLabel(){
  if(S.noOrder||!S.order) return S.answers.pfree||'le produit concerné';
  return S.selProducts.map(i=>S.order.products[i].n).join(' et ')||'le produit concerné';
}

const PROSE = {
  ruban(a){const s=[];const c=[];
    if(a.type) c.push('de type '+lc(strip(a.type)));
    if(a.tension) c.push('alimenté en '+a.tension);
    if(a.longueur) c.push("d'une longueur installée de "+a.longueur);
    s.push('Mon ruban LED est '+(c.length?c.join(', '):'installé chez moi')+'.');
    if(a.coupe) s.push(/^non/i.test(a.coupe)?"Je ne l'ai ni coupé ni rallongé.":(/rallong/i.test(a.coupe)?"Je l'ai rallongé (connecteur ou soudure).":"Je l'ai coupé aux marques prévues."));
    if(a.alim) s.push("Il est alimenté par un transformateur de "+withW(a.alim)+'.');
    if(a.enroule) s.push(/^Oui/i.test(a.enroule)?"Je précise qu'il est resté enroulé sur sa bobine pendant qu'il fonctionnait.":"Je l'avais bien déroulé pendant son fonctionnement.");
    return s;},
  transfo(a){const s=[];
    let base='Mon transformateur (driver)';
    if(a.tension) base+=' délivre du '+a.tension;
    if(a.puissance) base+=(a.tension?' pour une puissance de ':' a une puissance de ')+withW(a.puissance);
    s.push(base+'.');
    if(a.ptype&&!/sais pas/i.test(a.ptype)) s.push('Il est de type « '+lc(a.ptype)+' ».');
    if(a.charge) s.push('Il alimente '+a.charge+'.');
    if(a.avide) s.push(/^Oui/i.test(a.avide)?"Je l'ai déjà testé à vide, débranché de sa charge.":"Je ne l'ai pas encore testé à vide.");
    if(a.variateur) s.push(/^Non/i.test(a.variateur)?"Il est en alimentation directe, sans variateur.":'Il est branché '+lc(a.variateur)+'.');
    return s;},
  ampoule(a){const s=[];
    s.push('Mon ampoule LED'+(a.culot?' a un culot '+a.culot:' est installée chez moi')+'.');
    if(a.variateur) s.push(a.variateur==='Oui'?"Elle est installée sur un variateur (dimmer).":(a.variateur==='Non'?"Elle n'est pas raccordée à un variateur.":"Je ne sais pas si elle est raccordée à un variateur."));
    if(a.ferme) s.push(/^Oui/i.test(a.ferme)?"Elle est montée dans un luminaire fermé ou encastré, où la chaleur se dissipe mal.":"Elle est montée dans un luminaire ouvert et bien aéré.");
    if(a.inter&&a.inter==='Oui') s.push("Mon interrupteur a un voyant lumineux (je le signale car ça peut causer un scintillement).");
    return s;},
  spot(a){const s=[];
    s.push('Mes spots / encastrables sont alimentés en '+(a.tension?lc(a.tension):'?')+'.');
    if(a.nb) s.push("J'ai "+a.nb+' spot(s) raccordés sur le même transformateur.');
    if(a.driver&&!/sais pas/i.test(a.driver)) s.push(/origine/i.test(a.driver)?"J'utilise le driver d'origine fourni.":"J'ai remplacé le driver par un autre modèle.");
    return s;},
  plafonnier(a){const s=[];
    let b='Mon plafonnier / ma dalle';
    if(a.driver&&!/sais pas/i.test(a.driver)) b+=/intégr/i.test(a.driver)?' a une alimentation intégrée':' a un driver externe';
    s.push(b+'.');
    if(a.commande) s.push('Je le pilote par '+lc(a.commande)+'.');
    return s;},
  projecteur(a){const s=[];
    s.push('Mon projecteur est en usage '+(lc(a.usage)||'non précisé')+'.');
    if(a.detecteur) s.push(a.detecteur==='Oui'?"Il est équipé d'un détecteur de mouvement.":"Il n'a pas de détecteur de mouvement.");
    return s;},
  telecommande(a){const s=[];
    s.push('Ma télécommande / mon contrôleur'+(a.techno&&!/sais pas/i.test(a.techno)?' est en '+a.techno:'')+'.');
    if(a.zones) s.push('Je pilote '+a.zones+' récepteur(s) ou zone(s).');
    if(a.distance) s.push("La distance jusqu'au récepteur est d'environ "+a.distance+'.');
    if(a.pile) s.push(a.pile==='Oui'?"J'ai déjà changé ou testé la pile.":"Je n'ai pas encore changé la pile.");
    return s;},
  reglette(a){const s=[];
    s.push('Ma réglette / mon tube LED'+(a.longueur?' fait '+a.longueur:'')+'.');
    if(a.serie) s.push(/^Oui/i.test(a.serie)?"J'en ai plusieurs raccordées en série.":"Je n'en ai qu'une seule.");
    if(a.starter&&!/objet/i.test(a.starter)) s.push(a.starter==='Oui'?"J'ai retiré ou shunté le starter (montage tube rétrofit).":"Je n'ai pas retiré le starter.");
    return s;},
  connecte(a){const s=[];
    s.push('Mon produit connecté'+(a.app?" se pilote via l'application "+a.app:'')+'.');
    if(a.wifi) s.push(/^Oui/i.test(a.wifi)?"J'ai bien un réseau WiFi 2,4 GHz.":(/^Non/i.test(a.wifi)?"Je n'ai pas de WiFi 2,4 GHz (uniquement du 5 GHz), ce qui peut expliquer l'échec d'appairage.":''));
    return s.filter(Boolean);},
  autre(){return [];}
};

function techParagraph(){
  const a=S.answers, fam=FAMILLES[S.famille];
  if(!fam) return '';
  const sentences=(PROSE[S.famille]?PROSE[S.famille](a):[]).slice();
  if(a.sympt) sentences.push('Le symptôme que je constate : '+lc(a.sympt)+'.');
  if(a.desc) sentences.push('Je précise : « '+a.desc+' ».');
  return sentences.join(' ');
}

function motifParagraph(){
  const a=S.answers;
  if(S.motif==='casse'){
    let s=`J'ai reçu mon colis le ${a.recdate||'(date non précisée)'}. `;
    s+= /^Oui/i.test(a.pack||'')?"L'emballage extérieur était visiblement endommagé (carton écrasé ou déchiré). ":"L'emballage extérieur était intact, mais le produit à l'intérieur est arrivé cassé. ";
    if(a.desc) s+='Concrètement : '+a.desc+'.';
    return s.trim();
  }
  if(S.motif==='erreur') return `Je devais recevoir ${prodLabel()}, mais j'ai reçu à la place ${a.got||'un autre article'}${a.refgot?` (référence ${a.refgot} indiquée sur l'étiquette)`:''}.`;
  if(S.motif==='manquant'){
    let s=`Il manque un ou plusieurs éléments dans mon colis : ${a.desc||'(non précisé)'}.`;
    if(a.sealed) s+= /^Oui/i.test(a.sealed)?" Le colis était pourtant scellé à la réception.":" Le colis n'était pas scellé et semblait déjà ouvert.";
    return s;
  }
  if(S.motif==='retract'){
    let s=`Je souhaite exercer mon droit de rétractation (14 jours). Le produit est ${lc(a.used||'(état non précisé)')}.`;
    if(a.desc) s+=' Motif : '+a.desc+'.';
    return s;
  }
  if(S.motif==='garantie') return `Ma question : « ${a.desc||''} ».`;
  return '';
}

function buildMessage(){
  const a=S.answers, P=[];
  P.push('Bonjour,');
  let intro=`Je vous contacte au sujet de ${prodLabel()}`;
  if(S.order) intro+=`, que j'ai commandé le ${S.order.date} (commande ${S.order.id})`;
  if(S.motif==='defaut'){ intro+='. Ce produit rencontre un problème'; if(a.when) intro+=', apparu '+lc(a.when); intro+='.'; }
  else intro+='.';
  P.push(intro);
  if(S.motif==='defaut'){
    const t=techParagraph(); if(t) P.push(t);
    P.push("J'ai déjà tenté un dépannage de base (couper le courant une dizaine de secondes, vérifier l'alimentation), sans succès.");
  }else{
    const m=motifParagraph(); if(m) P.push(m);
  }
  const solMap={remplacement:"un remplacement à l'identique",reparation:'une réparation ou un dépannage',avoir:'un avoir',remboursement:'un remboursement',info:'simplement une réponse ou un conseil'};
  let close='';
  if(S.solution) close+=`Je souhaiterais ${solMap[S.solution]}. `;
  close+= S.files.length?`Je joins ${S.files.length} fichier${S.files.length>1?'s':''} à l'appui de ma demande.`:"Je n'ai pas joint de photo pour le moment.";
  P.push(close.trim());
  P.push("Merci d'avance pour votre aide.");
  P.push('Cordialement,');
  P.push(`${S.contact.nom||''}${S.contact.email?'  ·  '+S.contact.email:''}${S.contact.tel?'  ·  '+S.contact.tel:''}`);
  return P;
}

/* ---------- interactions ---------- */
